import React from 'react';
import { useMultiSelect } from './MultiSelectProvider';

export default function MultiSelectCount() {
    const { selectedOptions } = useMultiSelect();

    if (!selectedOptions?.length) return null;

    return <span>({selectedOptions.length})</span>;
}
